import orderInstance from './instance'

const updateOrder = (orderId, data) => {
  return orderInstance.put('/orders/' + orderId, data)
}

export default updateOrder
